<div class="attach-img float-start mx-2 mb-4" *ngFor="let file of fileList">
    <div *ngIf="file.isImage" class="image-tools">
        <button class="m-1"
            *ngIf="attachmentType != AttachmentType.JobNoteAttachment && attachmentType != AttachmentType.Emails && isReadOnly != true"
            (click)="editImage(file)">
            <mat-icon class="material-icons-outlined" mat-list-icon>edit
            </mat-icon>
        </button>
        <button class="m-1" (click)="viewImage(file)">
            <mat-icon class="material-icons-outlined" mat-list-icon>visibility
            </mat-icon>
        </button>
    </div>
    <div *ngIf="file.isImage && file.comment" class="comment-indicator">
        <mat-icon class="material-icons-outlined mat-icon-14" mat-list-icon>comment
        </mat-icon>
    </div>
    <div *ngIf="file.isVideo" class="image-tools">
        <button class="m-1" (click)="viewVideo(file)">
            <mat-icon mat-list-icon>play_arrow
            </mat-icon>
        </button>
    </div>
    <div class="invoice-tag" *ngIf="file.attachmentType == attachmentTypeEnum?.InvoiceByProvider || file.attachmentType == attachmentTypeEnum?.InvoiceWithWatermarkByProvider">
        <span *ngIf="isShowAsQuoteAttachment(file)">Quote</span>
        <span *ngIf="!isShowAsQuoteAttachment(file)">Invoice</span>
    </div>
    <div class="invoice-tag" *ngIf="file.attachmentType == attachmentTypeEnum?.CreditorInvoice">
        <span>Invoice</span>
    </div>
    <div class="invoice-tag" *ngIf="file.attachmentType == attachmentTypeEnum?.PmAcceptedQuoteAttachment">
        Quote
    </div>
    <div class="invoice-img-tag" *ngIf="showBeforeAfterTag == true && isImage(file) &&file.attachmentType != attachmentTypeEnum?.InvoiceByProvider && file.attachmentType != attachmentTypeEnum?.InvoiceWithWatermarkByProvider 
        && file.attachmentType != attachmentTypeEnum?.CreditorInvoice && file.attachmentType != attachmentTypeEnum?.PmAcceptedQuoteAttachment">
        <span *ngIf="file.isAfter">After</span>
        <span *ngIf="!file.isAfter">Before</span>
    </div>
    <img [src]="file?.blobUrl" class="rounded img-fluid asset-image-gird" alt="gallery images" *ngIf="file.isImage">
    <div *ngIf="file.isOther" rel="noopener" class="link-attachment pointer">
        <a *ngIf="file.isPdf" (click)="openPdf(file)"><img src="/assets/images/attached-file-pdf.svg"
                [title]="file?.blobName" height="110"></a>
        <a *ngIf="file.isCsv" (click)="download(file.blobUrl)"><img src="/assets/images/attached-file-csv.svg"
                [title]="file?.blobName" height="110"></a>
        <a *ngIf="file.isMsg" (click)="download(file.blobUrl)"><img src="/assets/images/attached-file-msg.svg"
                [title]="file?.blobName" height="110"></a>
        <a *ngIf="file.isEml" (click)="download(file.blobUrl)"><img src="/assets/images/attached-file-eml.svg"
                [title]="file?.blobName" height="110"></a>
        <a *ngIf="file.isTiff" (click)="download(file.blobUrl)"><img src="/assets/images/attached-file-tiff.svg"
                [title]="file?.blobName" height="110"></a>
    </div>
    <video [src]="file?.blobUrl" height="110" *ngIf="file.isVideo"></video>
    <div class="delete-icon cursor-pointer" *ngIf="showremoveFile">
        <mat-icon class="material-icons-outlined" mat-list-icon (click)="deleteFile(file)">close</mat-icon>
    </div>
</div>


<mat-drawer-container [hasBackdrop]="true" class="custom-drawer">
    <mat-drawer class="lg" mode="over" position="end" [(opened)]="isOpenImageDrawer"
        *ngIf="isOpenImageDrawer && !isImageEditor">
        <app-image-gallery [selectedImage]="getOriginalImageAttachment(attDetails)" [imageList]="imageList" [showBeforeAfterTag]="showBeforeAfterTag"
            (closeEvent)="closeImageDrawer()">
        </app-image-gallery>
    </mat-drawer>
    <mat-drawer class="xl" mode="over" position="end" [(opened)]="isOpenImageDrawer"
        *ngIf="isOpenImageDrawer && isImageEditor">
        <app-image-editor [imgJobId]="jobId" [selectedImage]="attDetails" (closeEvent)="closeImageDrawer()">
        </app-image-editor>
    </mat-drawer>
    <mat-drawer class="xl" mode="over" position="end" [(opened)]="isOpenPdfDrawer" *ngIf="isOpenPdfDrawer">
        <app-pdf-viewer [file]="fileSelected" (closeEvent)="closePdfDrawer()"></app-pdf-viewer>
    </mat-drawer>
    <mat-drawer class="lg" mode="over" position="end" [(opened)]="isOpenVideoDrawer" *ngIf="isOpenVideoDrawer">
        <app-video-viewer [file]="fileSelected" (closeEvent)="closeVideoDrawer()">
        </app-video-viewer>
    </mat-drawer>
</mat-drawer-container>
